module.exports = __webpack_public_path__ + "assets/Retina-ExLight.5c8a75e59f9cd026880d4cad5a895a49.woff";